import {A11yModule} from '@angular/cdk/a11y';
import {ConnectedPosition, OverlayModule} from '@angular/cdk/overlay';
import {NgTemplateOutlet} from '@angular/common';
import {ChangeDetectionStrategy, Component, ElementRef, Input, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

@Component({
    selector: 'app-popover',
    imports: [NgTemplateOutlet, A11yModule, OverlayModule, MatButtonModule, MatIconModule],
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopoverComponent {
    @Input() public popoverContent!: TemplateRef<unknown>;
    @Input({required: true}) public label!: string;
    @ViewChild('trigger', {read: ElementRef}) private trigger!: ElementRef<HTMLButtonElement>;
    public expanded = false;

    public readonly positions: ConnectedPosition[] = [
        {originX: 'start', overlayX: 'start', originY: 'bottom', overlayY: 'top', offsetY: 8},
        {originX: 'start', overlayX: 'start', originY: 'top', overlayY: 'bottom', offsetY: -8},
    ];

    public open(): void { this.trigger.nativeElement.focus(); this.expanded = true; }
    public close(): void { this.expanded = false; }

    public handleKeydown(event: KeyboardEvent): void {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        this.close();
    }
}
